import TIM from 'tim-js-sdk';
export function langText (val) {
  let judge = true
  switch (val) {
    case 'setOk':
      return judge ? 'setup successful' : '设置成功'
    case 'setErr':
      return judge ? 'setup failed' : '设置失败'
    case 'msgAt':
      return judge ? 'Have a message for you @' : '有您@的消息'
    case 'signInBefore':
      return judge ? 'confirm before' : '确认收到'
    case 'signInAfter':
      return judge ? 'confirm after' : '已确认'
    case 'signText':
      return judge ? 'Set the clocking message not to be empty' : '设置打卡的消息不能为空'
    case 'submitSuccess':
      return judge ? 'Submit Successfully' : '提交成功'
    case 'submitErr':
      return judge ? 'Submit Error' : '提交失败'
    case 'noFindMeData':
      return judge ? 'no find data for me' : '找不到我的群资料';
    case 'waitGroupData':
      return judge ? 'Waiting for group data acquisition' : '等待群资料获取';
    case 'networkQuality':
      return judge ? 'network quality' : '网络质量';
    case 'normal':
      return judge ? 'Normal' : '正常';
    case 'abnormal':
      return judge ? 'Abnormal' : '异常';
    case 'support':
      return judge ? 'support' : '支持';
    case 'unsupport':
      return judge ? 'unsupport' : '不支持';
    case 'DeviceConnecting':
      return judge ? 'Device in connection' : '设备正在连接中，请稍等';
    case 'DeviceConnectFail1':
      return judge ? 'Device connection failed, please allow web access to webcam and microphone' : '设备连接失败，请允许网页访问摄像头及麦克风';
    case 'NetConnectFail':
      return judge ? 'Network connection failed. Please check network connection' : '网络连接失败，请检查网络连接';
    case 'NetConnectSuccess':
      return judge ? 'Device and network connection successful, please start device detection' : '设备及网络连接成功，请开始设备检测';
    case 'DeviceConnectFail2':
      return judge ? 'Device and network connection failed. Please allow web access to webcam and microphone and check network connection' : '设备及网络连接失败，请允许网页访问摄像头及麦克风并检查网络连接';
    case 'deviceFailAttention':
      return judge ? `1. If prompted by the browser, select 'allow' <br>` +
        `2. If the antivirus software prompts, please select 'allow' < br >` +
        `3. Check the browser Settings to allow web access to the camera and microphone < br >` +
        `4. Check whether the camera / microphone is properly connected and on <br>` +
        `5. Try reconnecting camera / microphone < br >` +
        `6. Try to restart the computer and test again` :
        '1. 若浏览器弹出提示，请选择“允许”<br>' +
        '2. 若杀毒软件弹出提示，请选择“允许”<br>' +
        '3. 检查浏览器设置，允许网页访问摄像头及麦克风<br>' +
        '4. 检查摄像头/麦克风是否正确连接并开启<br>' +
        '5. 尝试重新连接摄像头/麦克风<br>' +
        '6. 尝试重启电脑后重新检测';
    case 'networkFailAttention':
      return judge ? '1. Please check whether the device is connected to the Internet <br>' + '2. Please refresh the webpage and check <br>' + '3.Please try to replace the network and test again.' : '1. 请检查设备是否联网<br>' + '2. 请刷新网页后再次检测<br>' + '3. 请尝试更换网络后再次检测';
    case 'NETWORK_QUALITY':
      return judge ? {
        '0': 'unknown',
        '1': 'excellent',
        '2': 'preferably',
        '3': 'ordinary',
        '4': 'bad',
        '5': 'very bad',
        '6': 'disconnect'
      } : {
        '0': '未知',
        '1': '极佳',
        '2': '较好',
        '3': '一般',
        '4': '差',
        '5': '极差',
        '6': '断开'
      };
    case 'pageCallbackConfig':
      return {
        'camera-testing-body': 'startCameraTesting',
        'voice-testing-body': 'startVoiceTesting',
        'mic-testing-body': 'startMicTesting',
        'network-testing-body': 'startNetworkTesting'
      }
    case 'inputText':
      return judge ? 'Please input content' : '请输入内容'
    case 'screenNot':
      return judge ? 'The current browser does not support screen sharing' : '当前浏览器不支持屏幕分享'
    case 'myTM':
      return judge ? 'My TM' : '我的TM'
    case 'myTeacher':
      return judge ? 'My Teacher' : '我的老师'
    case 'reStartText':
      return judge ? ' and click the button below to restart when you are done' : ',解决完之后可点击下方按钮重启'
    case 'mediaError':
      return judge ? 'Equipment acquisition error , video conferencing is not possible' : '设备获取错误,无法进行视频会议'
    case 'restartCamera':
      return judge ? 'Restart the camera' : '重启摄像头'
    case 'restartMicrophone':
      return judge ? 'Restart the microphone' : '重启语音'
    case 'SecurityError':
      return judge ? 'Security Error' : "安全错误"
    case 'AbortError':
      return judge ? 'An unknown error causes an abort' : "未知错误导致中止"
    case 'OverConstrainedError':
      return judge ? 'The constraints object specified requirements cannot be met by the device' : "constraints对象指定的要求无法被设备满足"
    case 'TypeError':
      return judge ? 'The constraints object is not set, or both are false' : "constraints对象未设置，或都为false"
    case 'NotAllowedErrorVideo':
      return judge ? 'Your browser does not allow the use of cameras.Please set "Camera" to "Allow" in the browser Settings and try again' : "您的浏览器禁止使用摄像头，请在浏览器设置中将“摄像头”设置为“允许”,并重试"
    case 'NotAllowedErrorAudio':
      return judge ? 'Your browser does not allow the use of cameras.Please set "microphone" to "Allow" in the browser Settings and try again' : "您的浏览器禁止使用语音，请在浏览器设置中将“语音”设置为“允许”,并重试"
    case 'NotReadableErrorVideo':
      return judge ? 'The camera is temporarily unavailable, please make sure there is no other application currently requesting access to the camera and try again' : "暂时无法访问摄像头，请确保当前没有其他应用请求访问摄像头，并重试"
    case 'NotReadableErrorAudio':
      return judge ? 'The microphone is temporarily unavailable, please make sure there is no other application currently requesting access to the microphone and try again' : "暂时无法访问麦克风，请确保当前没有其他应用请求访问麦克风，并重试"
    case 'isNotChrome':
      return judge ? 'Recommend downloading the latest version of Chrome' : '建议使用最新版Chrome浏览器'
    case 'checkSystem':
      return judge ? 'Your browser is not compatible with this application! \nI recommend downloading the latest version of Chrome' : '您的浏览器不兼容此应用！\n建议下载最新版Chrome浏览器'
    case 'phoning':
      return judge ? 'In the middle of a phone call, do not trigger' : '正在电话通话中，不可切换'
    case 'voicing':
      return judge ? 'In the middle of a voice call, do not trigger' : '正在语音通话中，不可切换'
    case 'videoing':
      return judge ? 'In the middle of a video call, do not trigger' : '正在视频通话中，不可切换'
    case 'systemInform':
      return judge ? 'System Inform' : '系统通知'
    case 'processed':
      return judge ? 'Has processed' : '已处理'
    case 'joined':
      return judge ? 'Has joined' : '已加入'
    case 'WaitJoin':
      return judge ? 'Waiting to join...' : '等待加入'
    case 'left':
      return judge ? 'Has left' : '已离开'
    case 'refuseJoin':
      return judge ? 'Refused to join' : '拒绝加入'
    case 'fileLimit':
      return judge ? ' file size must not exceed ' : '文件大小不能超过'
    case 'myVideo':
      return judge ? 'my video' : '我的视频'
    case 'sharedVideo':
      return judge ? 'Current Screen' : '当前的视频'
    case 'shareScreen':
      return judge ? 'Sharing Screen' : '共享屏幕'
    case 'roomIn':
      return judge ? 'Already in a meeting for you' : '你已经在一个房间里'
    case 'notRoomIn':
      return judge ? 'Already not in a meeting' : '已经不在会议里'
    case 'over20':
      return judge ? 'more than 20 persons' : '已超过20人'
    case 'isNoCameras':
      return judge ? 'Lack of cameras' : '缺少摄像头'
    case 'isNoMicrophones':
      return judge ? 'Lack of microphones' : '缺少麦克风'
    case 'autoReply':
      return judge ? "[auto reply] Hello, I have something not in now, please leave a message." : '[自动回复]你好，我现在有事不在，一会再和你联系'
    case 'fileUnPass':
      return judge ? "The file does not pass" : '文件不符合要求'
    case 'context':
      return judge ? "View context" : '查看上下文'
    case 'unMsgJump':
      return judge ? "Retracted unable to jump" : '已撤回无法跳转'
    case 'revokeEdit':
      return judge ? "Withdraw the editor" : '撤回编辑'
    case 'phoneAudioVideoInRefuse1':
      return judge ? "The other party is on a phone call, please contact later" : '对方正在电话通话中，请稍后联系'
    case 'phoneAudioVideoInRefuse2':
      return judge ? "The other party is on a voice call, please contact later" : '对方正在语音通话中，请稍后联系'
    case 'phoneAudioVideoInRefuse3':
      return judge ? "The other party is on a video call, please contact later" : '对方正在视频通话中，请稍后联系'
    case 'noAnswer':
      return judge ? "No answer" : '没有人应答'
    case 'audioCallFor':
      return judge ? ' invite you to audio call' : '邀请您语音通话'
    case 'voiceCall':
      return judge ? '[Invite you to make a voice call]' : '[对方邀请你语音通话]'
    case 'voiceCallEnd':
      return judge ? '[End of voice call]' : '[语音通话结束]'
    case 'voiceCallCancel':
      return judge ? "The call was canceled" : '语音通话取消'
    case 'voiceCallReject':
      return judge ? "The call was denied" : '语音通话拒绝'
    case 'voiceCallJoin':
      return judge ? "Invited to a voice call" : '邀请参加一个语音通话'
    case 'voiceCallResolve':
      return judge ? "Confirmed to join voice channel" : '已确定加入语音频道'
    case 'videoCallFor':
      return judge ? ' invite you to video call' : '邀请您视频通话'
    case 'videoCall':
      return judge ? '[invite you to make a video call]' : '[对方邀请你视频通话]'
    case 'videoCallEnd':
      return judge ? '[End of video call]' : '[视频通话结束]'
    case 'videoCallCancel':
      return judge ? "The call was canceled" : '视频通话取消'
    case 'videoCallReject':
      return judge ? "The call was denied" : '视频通话拒绝'
    case 'videoCallJoin':
      return judge ? "You're invited to a video call" : '你被邀请参加一个视频通话'
    case 'videoCallResolve':
      return judge ? "Confirmed to join the video conference" : '已确定加入视频会议'
    case 'phone-call':
      return judge ? "Forward call" : '正电话拨打'
    case 'phone-cancel':
      return judge ? "hand up" : '取消电话拨打'
    case 'audioTime':
      return judge ? 'Length of audio call' : '语音时长'
    case 'videoTime':
      return judge ? 'Length of video call' : '视频时长'
    case 'phoneTime':
      return judge ? 'Length of phone call' : '通话时长'
    case 'addGroupMemberErr':
      return judge ? ' failed to add a group member' : '该群成员添加失败'
    case 'addGroupMemberS':
      return judge ? ' succeeded to add a group member' : '该群成员添加成功'
    case 'addErr':
      return judge ? 'Failed to add a group member' : '添加群成员失败'
    case 'invite':
      return judge ? ' invited ' : '邀请'
    case 'morePerson':
      return judge ? ' and other  ' : '等'
    case 'joinChat':
      return judge ? ' people to join the group chat' : '人加入群聊'
    case 'overText2000':
      return judge ? 'The specified number of words has been exceeded 2000. Please reduce the number of words sent' : '已超过规定2000字数，请减少发送文字字数'
    case 'overText150':
      return judge ? 'The specified number of words has been exceeded 150. Please reduce the number of words sent' : '已超过规定150字数，请减少发送文字字数'
    case 'overText50':
      return judge ? 'The specified number of words has been exceeded 50. Please reduce the number of words sent' : '已超过规定50字数，请减少发送文字字数'
    case 'overFile':
      return judge ? 'The specified file size has been exceeded 50M. Please reduce the sending file size' : '已超过规定文件50M大小，请降低发送文件大小'
    case 'confirm':
      return judge ? 'confirm' : '确定'
    case 'closed':
      return judge ? 'closed' : '已关闭'
    case 'opened':
      return judge ? 'opened' : '已开启'
    case 'DetailNotification':
      return judge ? 'Detail notification' : '公告详情'
    case 'ModifyNotification':
      return judge ? 'Modify notification' : '修改公告'
    case 'DeleteNotification':
      return judge ? 'Delete notification' : '删除公告'
    case 'noSetTeacher':
      return judge ? 'Cannot set teacher to group owner' : '不可把老师设置为群主'
    case 'audioInvite':
      return judge ? ' invite you to voice call' : '邀请你语音通话'
    case 'videoInvite':
      return judge ? ' invite you to video call' : '邀请你视频通话'
    case 'msgReadErr':
      return judge ? 'The message failed to read' : '消息已读失败'
    case 'fileSize':
      return judge ? 'Files cannot be larger than ' : '文件不能大于'
    case 'fileNone':
      return judge ? 'file does not exist' : '文件不存在'
    case 'more':
      return judge ? 'load more' : '加载更多'
    case 'noMore':
      return judge ? 'no more' : '已无更多'
    case 'clickBack':
      return judge ? 'Click on the back' : '点击收回'
    case 'showAll':
      return judge ? 'show all' : '显示所有'
    case 'group':
      return judge ? 'discussion group' : '讨论组'
    case 'sysMsg':
      return judge ? 'system Message' : '系统消息'
    case 'success':
      return judge ? ' success ' : '成功'
    case 'error':
      return judge ? ' error ' : '失败'
    case 'successEdit':
      return judge ? ' success ' : '修改成功'
    case 'errorEdit':
      return judge ? ' error ' : '修改失败'
    case 'contacts':
      return judge ? ' contacts ' : '联系人'
    case 'hisRecored':
      return judge ? ' history recored ' : '历史记录'
    case 'AgreeJoin':
      return judge ? ' Agree ' : '已同意加群申请!'
    case 'rejectJoin':
      return judge ? 'reject' : '已拒绝加群申请!'
    case 'applyed':
      return judge ? 'reject' : '申请已处理'
    case 'applyErr':
      return judge ? 'dispose application failed' : '处理加群申请失败'
    case 'ModifiedGroupSuccess':
      return judge ? 'Modified group data successfully' : '修改群资料成功'
    case 'ModifiedGroupFail':
      return judge ? 'Modified group data unsuccessfully' : '修改群资料失败'
    case 'GroupNoMember':
      return judge ? 'The group currently has no members' : '该群组目前没有成员'
    case 'Owner':
      return judge ? 'group owner' : '群主'
    case 'Admin':
      return judge ? 'group Administrator' : '管理员'
    case 'Member':
      return judge ? 'group member' : '成员'
    case 'delTeamMember':
      return judge ? 'Remove Members' : '移出群聊'
    case 'transferOwner':
      return judge ? 'Transfer Ownership' : '转让群主'
    case 'sureTransferOwner':
      return judge ? 'After transferring group owner, you will become an ordinary group member. Please confirm whether to transfer group owner?' : '转让群主后，您将成为普通群成员，请确认是否转让群主？'
    case 'waitAgree':
      return judge ? "Waiting for administrator's approval" : '等待管理员同意'
    case 'JoinSuccess':
      return judge ? "Join the success" : '加入成功'
    case 'GroupDisbanded':
      return judge ? "The group has disbanded" : '群已经解散'
    case 'GroupExited':
      return judge ? "You have successfully exited the group" : '您已成功退出群'
    case 'removeMember':
      return judge ? "Determine to remove the member" : '确定移除该成员'
    case 'mekickOut':
      return judge ? "You've been kicked out" : '你已被踢出'
    case 'kickOutOver':
      return judge ? "You've been kicked out" : '已踢出'
    case 'SetupFail':
      return judge ? 'Setup failed' : '设置失败'
    case 'fileUp':
      return judge ? 'files upload' : '文件上传'
    case 'headOk':
      return judge ? 'Avatar uploaded successfully' : '头像上传成功'
    case 'headErr':
      return judge ? 'Avatar uploaded failed' : '头像上传失败'
    case 'emptyFile':
      return judge ? 'Cannot pass empty file' : '不能传空文件'
    case 'welcome':
      return judge ? 'welcome' : '欢迎欢迎'
    case 'publicGroup':
      return judge ? 'public group' : '公开群'
    case 'privateGroup':
      return judge ? 'private group' : '私有群'
    case 'buildGroupOk':
      return judge ? 'The discussion group was created successfully' : '创建讨论组成功'
    case 'searchErr':
      return judge ? 'Search for the error' : '搜索错误'
    case 'groupNameNone':
      return judge ? 'The group name you entered is empty. Please re-enter the group name' : '您输入的群组名称为空,请重新输入群组名称'
    case 'groupNameLimit':
      return judge ? 'The group name you entered exceeded the limit (maximum 30 bytes)' : '您输入的群组名称字数超出限制(最长30字节)'
    case 'NotificationNameLimit':
      return judge ? 'The group announcement you entered is over the limit (up to 300)' : '您输入的群组公告内容字数超出限制(最长300字)'
    case 'IntroductionNameLimit':
      return judge ? 'The group profile you entered is beyond the limit (maximum 240 bytes)' : '您输入的群组简介字数超出限制(最长240字节)'
    case 'QuestionNameLimit':
      return judge ? 'The number of words you enter in the question exceeds the limit (maximum 200 bytes)' : '您输入的问题字数超出限制(最长200字节)'
    case 'authorizedNone':
      return judge ? 'Your account is not authorized to use IM chat' : '您的账号暂未开通使用im聊天功能的权限'
    case 'loginFailure':
      return judge ? 'login failure' : '登录失败'
    case 'logout':
      return judge ? 'logout' : '退出登录'
    case 'myDataGetErr':
      return judge ? 'Personal data access failed' : '个人资料获取失败'
    case 'myUpdateErr':
      return judge ? 'Personal data update failed' : '个人资料更新失败'
    case 'latestContactGetErr':
      return judge ? 'Failed to get the latest contact' : '获取最近联系人失败'
    case 'msgSendFail':
      return judge ? 'Message sending failed' : '消息发送失败'
    case 'msgRetractFail':
      return judge ? 'Message retract failed' : '消息撤回失败'
    case 'groupSysGetFail':
      return judge ? 'Failed to get group system messages' : '获取群系统消息失败'
    case 'HistoryGetFail':
      return judge ? 'History retrieval failed' : '历史记录获取失败'
    case 'groupNone':
      return judge ? 'The group does not exist or has been dissolved' : '群组不存在或已解散'
    case 'groupListFail':
      return judge ? 'Group list fetch failed' : '群列表获取失败'
    case 'groupDataFail':
      return judge ? 'Group data fetch failed' : '群资料获取失败'
    case 'groupBuildFail':
      return judge ? 'Group build failed' : '创建群失败'
    case 'grouppromptSetFail':
      return judge ? 'Group message prompt type failed' : '群消息提示类型失败'
    case 'groupOwnerSetFail':
      return judge ? 'Group owner change failed' : '群主更改失败'
    case 'groupMemberGetFail':
      return judge ? 'Group member acquisition failed' : '群员获取失败'
    case 'groupAdditionFail':
      return judge ? 'Application for group addition operation failed' : '申请加群操作失败'
    case 'groupDisbandFail':
      return judge ? 'Group disband failure' : '群解散失败'
    case 'groupExitFail':
      return judge ? 'Group exit failure' : '群退出失败'
    case 'groupMemberDeleteFail':
      return judge ? 'Deletion of group members failed' : '删除群成员失败'
    case 'ContactDateGetFail':
      return judge ? 'Failed to obtain contact information' : '获取联系人资料失败'
    case 'online':
      return judge ? 'online' : '在线'
    case 'offline':
      return judge ? 'offline' : '离线'
    case 'nomessage':
      return judge ? 'no message' : '暂无消息'
    case 'read':
      return judge ? 'read' : '已读'
    case 'teamInvite':
      return judge ? 'Invite you into the group' : '邀请你入群'
    case 'answer':
      return judge ? 'answer' : '接听'
    case 'reject':
      return judge ? 'reject' : '拒绝'
    case 'pass':
      return judge ? 'pass' : '同意'
    case 'rejected':
      return judge ? 'rejected' : '已拒绝'
    case 'passed':
      return judge ? 'passed' : '已同意'
    case 'failure':
      return judge ? 'failure' : '失效'
    case 'unknown':
      return judge ? 'unknown' : '未知'
    case 'applyTeam':
      return judge ? 'Apply for group membership' : '申请加入群'
    case 'ContinueChat':
      return judge ? 'Continue to chat' : '继续聊天'
    case 'rejectTeamApply':
      return judge ? 'Refused your invitation to join the group' : '拒绝了你的入群邀请'
    case 'image':
      return judge ? '[image]' : '[图片]'
    case 'file':
      return judge ? '[file]' : '[文件]'
    case 'group_create':
      return judge ? 'Successfully create a discussion group' : '成功创建讨论组'
    case 'noSelect':
      return judge ? "You haven't selected friends or groups yet, so you can't chat" : '你还没有选中好友或者群组，暂不能聊天'
    case 'noText':
      return judge ? 'The message sent cannot be empty' : '发送的消息不能为空'
    case 'sendErr':
      return judge ? 'sendErr' : '发送失败'
    case 'msgReminding':
      return judge ? 'message reminding' : '消息提醒'
    case 'nickEmpty':
      return judge ? 'Nicknames cannot be empty' : '昵称不能为空'
    case 'emailIncorrect':
      return judge ? 'The email format is incorrect' : 'email格式不正确'
    case 'NoteModificationSuccess':
      return judge ? 'Note modification successful' : '修改备注成功'
    case 'NoteModificationErr':
      return judge ? 'Note modification successful' : '修改备注成功'
    case 'failAddFriend':
      return judge ? 'Failed to add friends' : '添加好友失败'
    case 'delete':
      return judge ? 'Make sure to delete' : '确定要删除'
    case 'delFriendFail':
      return judge ? 'Friend deletion failed' : '删除好友失败'
    case 'operationFail':
      return judge ? 'operation failure' : '操作失败'
    case 'searchErr':
      return judge ? 'Please try researching again' : '请再尝试重新搜索'
    case 'imageLimit':
      return judge ? 'Picture length and width must not be less than 300' : '图片长宽不能小于300'
    case 'avatarFail':
      return judge ? 'Failed to modify group avatar' : '修改群头像失败'
    case 'uploadPhoto':
      return judge ? 'Please upload a photo' : '请上传一张头像'
    case 'msgNone':
      return judge ? 'This information is not available' : '暂无此信息'
    case 'InviteMembers':
      return judge ? 'Invite members' : '邀请成员'
    case 'cancelAdministrator':
      return judge ? 'cancel administrator' : '取消管理员'
    case 'promptSetAdministrator':
      return judge ? 'Add group Admin' : '设置为管理员'
    case 'notRemoveMe':
      return judge ? 'You cannot remove yourself' : '您不能自己移除自己'
    case 'targetNoIn':
      return judge ? 'The removed target is no longer in the group' : '移除的目标已不在群内'
    case 'meNoIn':
      return judge ? 'You are not in the group' : '您不在群内'
    case 'noRemoveOwner':
      return judge ? 'You cannot remove group manager' : '您不能移除群主'
    case 'noRemoveAdmin':
      return judge ? 'You cannot remove other administrators, only group manager is eligible to remove administrators' : '您不能移除其他管理员,只有群主才有资格移除管理员'
    case 'noRemoveMember':
      return judge ? 'Only administrators can remove members' : '只有管理人员才可以进行移除成员操作'
    case 'promptQuitGroup':
      return judge ? 'Do you really want to quit the discussion group ?' : '您真的要退出该讨论组吗？'
    case 'promptDisbandGroup':
      return judge ? 'Do you really want to disband the group ?' : '您真的要解散该讨论组吗？'
    case 'members':
      return judge ? ' members ' : '人 '
    case 'will':
      return judge ? ' will ' : '将 '
    case 'tipsMemberAdd':
      return judge ? ' join the group , the number of current group members is :' : ' 加入该群，当前群成员数：'
    case 'tipsMemberLeave':
      return judge ? ' leave the group , the number of current group members is :' : ' 离开该群，当前群成员数：'
    case 'tipsMemberKicked':
      return judge ? ', kicked out the group' : '，踢出该群'
    case 'setAdministrator':
      return judge ? ', Set as administrator' : '，设为管理员'
    case 'cancel':
      return judge ? ' cancel ' : '取消'
    case 'AdministratorQualification':
      return judge ? ' administrator qualification ' : ' 管理员资格'
    case 'transferGroup':
      return judge ? ' transfer group manager to ' : '转让群主给'
    case 'GroupNameIs':
      return judge ? ' Group name for ' : ' 群名称为'
    case 'notificationIs':
      return judge ? ' Group notification for ' : ' 群公告为'
    case 'introductionIs':
      return judge ? ' Group introduction for ' : ' 群简介为'
    case 'modifiedMemberInformation':
      return judge ? ' modified group member information ' : ' 修改了群成员资料'
    case 'modifiedGroupInformation':
      return judge ? ' Modified group data: ' : ' 修改了群资料：'
    case 'revokeP2P':
      return judge ? 'The other party withdrew a message' : '对方撤回了一条消息'
    case 'revokeTeam':
      return judge ? ' withdrew a message' : '撤回了一条消息'
    case 'revokeMe':
      return judge ? 'me withdrew a message' : '我撤回了一条消息'
    case 'revokeOverTime':
      return judge ? 'Cannot be withdrawn for more than 2 minutes' : '已超过2分钟不能撤回'
    case 'groupFSet':
      return judge ? 'Set the group chat function as ' : '群聊功能设置为'
    case 'IsForbidden0':
      return judge ? 'Allow all group members to speak' : '允许所有群成员发言'
    case 'IsNoticeAll0':
      return judge ? 'Allow uncensored group members @ all' : '允许未被禁言群成员@所有人'
    case 'IsSendFile0':
      return judge ? 'Allows members of an uncensored group to send files' : '允许未被禁言群成员发送文件'
    case 'IsForbidden1':
      return judge ? 'Now only group manager and owner are now allowed to speak' : '现在只允许群主和管理员发言'
    case 'IsNoticeAll1':
      return judge ? 'Now only group manager and admin @ are allowed' : '现在只允许群主和管理员@所有人'
    case 'IsSendFile1':
      return judge ? 'Now only group manager and owner are now allowed to send files' : '现在只允许群主和管理员发送文件'
    case 'onlyPic':
      return judge ? 'You can only upload pictures' : '只能上传图片'
    default:
      return ''
  }
}
export let appUI = {
  currentType: null,
  authTypeJson: [],
  classStatus: ['AbsenceReminder', 'CancellationReminder', 'BookingReminder', 'ClassReminder', 'ComplaintReminder', 'ShiftClockReminder', "ComplaintWithdrawnReminder", 'SVIPBookingReminder'],
  teacherNickHide (type, nick) {
    if ((this.currentType == 3 || this.currentType == 99 || this.currentType == 17) && (type == 3 || type == 99 || type == 17)) {
      let newNick = nick.slice(0, 3) + '***'
      return newNick
    } else {
      return nick
    }
  },
  makeNick (nick, userId) {
    if (!nick) return {}
    nick = String(nick || '').replace(/\&nbsp;/g, ' ')
    let arr = this.authTypeJson, j
    for (let i = 0, len = arr.length; i < len; i++) {
      const ele = arr[i], index = nick.search(`/${ele.UserTypeName}`);
      if (index > 0) {
        nick = nick.slice(0, index);
        j = ele.UserType
        break
      }
    }
    if (j) {
      nick = this.teacherNickHide(j, nick)
    }
    return { nick: nick || '', index: j || 0 }
  },
  typeObject (str) {
    if (typeof str == 'string') {
      try {
        let obj = JSON.parse(str);
        if (str.indexOf('{') > -1) {
          return obj;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
    return false;
  },
  parseCallMsg (data) {
    // var SIGNALING_ACTION_TYPE_INVITE = 1;
    // var SIGNALING_ACTION_TYPE_CANCEL_INVITE = 2;
    // var SIGNALING_ACTION_TYPE_ACCEPT_INVITE = 3;
    // var SIGNALING_ACTION_TYPE_REJECT_INVITE = 4;
    // var SIGNALING_ACTION_TYPE_INVITE_TIMEOUT = 5;

    let judge, o = data, content = "", extra;
    if (o.businessID && o.businessID == "av_call") {
      return "";
    }
    if (o.actionType == 5) {
      return "[No answer]";
    }
    extra = JSON.parse(o.data);
    if (o.actionType < 1 || o.actionType > 7) {
      return false;
    }
    judge = extra.call_type == 1 ? 'audio' : 'video'
    if (o.actionType == 1) {
      if (extra.call_end !== undefined) {
        content = `[Length of ${judge} call:${this.s_to_hs(extra.call_end)}]`;
      } else {
        content = `[You're invited to a ${judge} call]`;
      }
    } else if (o.actionType == 2) {
      content = "[The call was canceled]";
    } else if (o.actionType == 3) {
      content = "[Confirmed to join voice channel]"
    } else if (o.actionType == 4) {
      if (extra.line_busy == '1') {
        content = "[The other party is on a phone call, please contact later]";
      } else if (extra.line_busy == '2') {
        content = "[The other party is on a voice call, please contact later]";
      } else if (extra.line_busy == '3') {
        content = "[The other party is on a video call, please contact later]";
      } else {
        content = "[The call was denied]";
      }
    } else if (o.actionType == 5) {
      content = "[No answer]";
    }
    return content;
  },
  s_to_hs (s) {
    //计算分钟
    //算法：将秒数除以60，然后下舍入，既得到分钟数
    var h;
    h = Math.floor(s / 60);
    //计算秒
    //算法：取得秒%60的余数，既得到秒数
    s = s % 60;
    //将变量转换为字符串
    h += '';
    s += '';
    //如果只有一位数，前面增加一个0
    h = (h.length == 1) ? '0' + h : h;
    s = (s.length == 1) ? '0' + s : s;
    return h + ':' + s;
  },
  mediaSend (sendText, desc, ext, actionType, inviter, roomId, call_type, busy, call_end, inviteeList, inviterid) {
    let o = {
      actionType,//参考上面的说明
      inviter: String(inviter),//房间id
      inviteID: inviterid,//唯一Id,
      inviteeList: inviteeList,//邀请的对象,因为目前只做单对单语音先简略
      timeout: 30,//超时时间，好像没用
      businessID: 1//好像固定是1
    }
    let data = {
      version: 4,
      call_type,//1为语音，2为视频
      room_id: roomId || Number(inviter),//可选，参考上面说明
      line_busy: busy,//可选，参考上面说明
      call_end,//时间，可选，参考上面说明
      data: sendText,
      desc,
      ext
    };//额外的参数
    o.data = JSON.stringify(data);
    return JSON.stringify(o)
  },
  htmlEncode (html) {
    var temp = document.createElement("div");
    (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
    var output = temp.innerHTML;
    temp = null;
    return output
  },
  htmlDecode (text) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output
  },
  //把消息转换成Html
  formatIsHtml2Text (html) {
    if (html) {
      html = html.toString();
      html = html.replace(/<br>/g, "\n");
      html = html.replace(/<br\/>/g, "\n");
      html = html.replace(/[<]/g, "&lt;");
      html = html.replace(/[>]/g, "&gt;");
      html = html.replace(/"/g, "&quot;");
      html = html.replace(/'/g, "&apos;");
      html = html.replace(/\\!/g, "!");
    }
    return html;
  },
  formatIsText2Html (html) {
    if (html) {
      html = html.toString();
      html = html.replace(/\&lt;/g, "& lt;");
      html = html.replace(/\&gt;/g, "& gt;");
      html = html.replace(/\&quot;/g, "& quot;");
      html = html.replace(/\&apos;/g, "& apos;");
      html = html.replace(/[<]/g, "&lt;");
      html = html.replace(/[>]/g, "&gt;");
      html = html.replace(/"/g, "&quot;");
      html = html.replace(/'/g, "&apos;");
      html = html.replace(/\\n/g, "<br>");
      html = html.replace(/\\!/g, "!");
    }
    return html;
  },
  formatText2Node (html) {
    if (html) {
      html = html.toString();
      html = html.replace(/&lt;/g, "<");
      html = html.replace(/&gt;/g, ">");
      html = html.replace(/&quot;/g, '"');
      html = html.replace(/&apos;/g, "'");
      html = html.replace(/&nbsp;/g, " ");
      html = html.replace(/!/g, "\\!");
      html = html.replace(/\n/g, "<br>");
    }
    return html;
  },
  convertMsgtoHtml (msg, judge) {
    let html = "", elem, type, content, elems = msg._elements, count = elems.length, conversationID = msg.conversationID;
    for (var i = 0; i < count; i++) {
      elem = elems[i];
      type = elem.type; //获取元素类型
      content = elem.content; //获取元素对象
      html += this.convertMsgtoHtmlType(conversationID, type, content, judge)
    }
    return html;
  },
  convertMsgtoHtmlType (conversationID, type, content, judge) {
    switch (type) {
      case TIM.TYPES.MSG_TEXT:
        return this.convertTextMsgToHtml(conversationID, content.text, judge);
      case TIM.TYPES.MSG_FACE:
        return this.convertFaceMsgToHtml(content);
      case TIM.TYPES.MSG_IMAGE:
        return this.convertImageMsgToHtml(content, judge);
      case TIM.TYPES.MSG_AUDIO:
        return this.convertSoundMsgToHtml(content);
      case TIM.TYPES.MSG_FILE:
        return this.convertFileMsgToHtml(content, judge);
      case TIM.TYPES.MSG_GEO:
        return this.convertLocationMsgToHtml(content);
      case TIM.TYPES.MSG_GRP_SYS_NOTICE:
        return '';
      case TIM.TYPES.MSG_GRP_TIP:
        var eleHtml = this.convertGroupTipMsgToHtml(content);
        //转义，防XSS
        return eleHtml;
      // return ''
      case TIM.TYPES.MSG_CUSTOM:
        var eleHtml = this.convertCustomMsgToHtml(conversationID, content, judge);
        //转义，防XSS
        return eleHtml;
      case TIM.TYPES.MSG_GRP_SYS_NOTICE:
        return ''
      default:
        console.log('未知消息元素类型: elemType=' + type);
    }
  },
  //解析文本消息元素
  convertTextMsgToHtml (conversationID, text, judge, desc, ext) {
    //解析文本和表情
    if (!text) return ''
    if (ext) {
      let style = 'font-size:18px;font-weight:600;color:#333;display: block;margin-bottom:5px;'
      if (this.classStatus.indexOf(desc) > -1) {
        let obj = {}, extC = JSON.parse(ext)
        for (let key in extC) {
          obj[key.toLowerCase()] = extC[key]
        }
        switch (desc) {
          case 'AbsenceReminder':
            text = `<title style='${style}'>Absence Reminder</title>
            <p>Class ID : ${obj.classid}</p>
            <p>Class time : ${new Date(obj.classtime).toLocaleString()}</p>
            <p>${obj.remark}</p>`
            break;
          case 'CancellationReminder':
            text = `<title style='${style}'>Cancellation Reminder</title>
            <p>Cancellation status: ${obj.cancellationstatus}</p>
            <p>Operation type: ${obj.operationtype}</p>
            <p>Operation time: ${new Date(obj.operationtime).toLocaleString()}</p>
            <p>Cancellation details: ${obj.cancellationdetails}</p>`
            break;
          case 'BookingReminder':
            text = `<title style='${style}'>Booking Reminder</title>
            <p>Class ID: ${obj.classid}</p>
            <p>Class time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Class type: ${obj.classtype}</p>
            <p class='${obj.remark ? '' : 'hide'}'>${obj.remark}</p>`
            break;
          case 'ClassReminder':
            text = `<title style='${style}'>Class Reminder</title>
            <p>${obj.remark}</p><p>Class ID: ${obj.classid}</p>
            <p>Class time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Class type: ${obj.classtype}</p>`
            break;
          case 'ComplaintReminder':
            text = `<title style='${style}'>Complaint Reminder</title>
            <p>Class ID: ${obj.classid}</p>
            <p>Class time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Generation time: ${new Date(obj.generationtime).toLocaleString()}</p>
            <p>Complainant: ${obj.complainant}</p>
            <p>Complaint reason: ${obj.complaintreason}</p>
            <p>${obj.remark}</p>`
            break;
          case 'ShiftClockReminder':
            text = `<title style='${style}'>Shift clock-in reminder</title>
            <p>${obj.remark}</p>`
            break;
          case "ComplaintWithdrawnReminder":
            text = `<title style='${style}'>Complaint withdrawn reminder</title>
            <p>${obj.remark}</p>`
            break;
          case "SVIPBookingReminder":
            text = `<title style='${style}'>SVIP Booking reminder</title>
            <p>Class ID: ${obj.classid}</p>
            <p>Class time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Class type: ${obj.classtype}</p>
            <p>${obj.remark}</p>`
            break;

          default:
            break;
        }
      } else {
        text = `<title style='${style}'>${ext}</title>` + text
      }
    } else if (conversationID == 'C2Cadmin' && !desc) {
      return ''
    }
    let expr = /\[[^[\]]{1,4}\]/mg, msgContent, faceHtml;
    if (judge) {
      return this.htmlEncode(text)
    }
    msgContent = this.formatText2Node(this.htmlDecode(this.htmlEncode(text)))
    let rmMsgCite = document.createElement('div')
    rmMsgCite.innerHTML = msgContent
    let msgCite = rmMsgCite.getElementsByClassName('msgCite'), msgCiteClone

    if (msgCite.length) {
      msgCiteClone = msgCite[0].cloneNode(true)
      rmMsgCite.removeChild(msgCite[0])
    }
    content = rmMsgCite.innerHTML
    faceHtml = content
    let div = document.createElement('div'), div2 = document.createElement('div')
    div.innerHTML = faceHtml
    let all
    if (msgCiteClone) {
      let fra = document.createRange().createContextualFragment(faceHtml)
      div2.appendChild(msgCiteClone)
      div2.appendChild(fra)
      all = div2.innerHTML
    } else {
      all = faceHtml
    }
    if (conversationID == 'C2Cadmin' || conversationID == 'C2CClassStatus') {
      return `<div class='msg-text'>${msgContent}</div>`
    } else {
      return `<div class='msg-text'>${all}</div>`
    }
  },
  nodeChilds (childs) {
    let textContent = ''
    for (let i = 0, len = childs.length; i < len; i++) {
      let ele = childs[i]
      if (ele.className && ((ele.className.indexOf('msgCite') > -1) || (ele.className.indexOf('at') > -1) || (ele.className.indexOf('emoji') > -1) || (ele.className.indexOf('url') > -1))) {
        let type = ele.dataset['type'], name = ele.dataset['name'], userId = ele.dataset['id']
        if (name && (name != 'undefined') && ele.className && (ele.className.indexOf('at') > -1) && (this.currentType == 3 || this.currentType == 99 || this.currentType == 17) && (type == 3 || type == 99 || type == 17) && (userId != loginInfo.identifier)) {
          ele.innerText = '@' + name.slice(0, 3) + '***'
        } else if (name && (name != 'undefined')) {
          ele.innerText = '@' + name
        }
        textContent += ele.outerHTML
        continue
      }
      if (ele.nodeName == 'BR') {
        textContent += '<br>'
      } else {
        textContent += this.formatIsText2Html(ele.outerHTML || ele.textContent)
      }
    }
    return this.htmlDecode(textContent)
  },
  //解析表情消息元素
  convertFaceMsgToHtml (content) {
    return langText('face')
  },
  //解析图片消息元素
  convertImageMsgToHtml (content, judge) {
    return langText('image')
  },
  convertImageMsgToHtmlDb (url) {
    return langText('image')
  },
  //解析文件消息元素
  convertFileMsgToHtml (content, judge) {
    return langText('file')
  },
  convertFileMsgToHtmlDb (url, fileSize, fileName) {
    let formatObj, html, videoJudge = false, unitStr = "B", numKb = 1024, numM = 1024 * 1024;
    if (fileSize >= numM) {
      fileSize = Math.round(fileSize / numM);
      unitStr = "M";
    } else if (fileSize >= numKb) {
      fileSize = Math.round(fileSize / numKb);
      unitStr = "KB";
    }
    formatObj = format(url)
    if (videoJudge) {//video暂时用不上
      html = `<div title="video (${fileSize + unitStr})" class="download-file f-maxWid msg-file videoBoxShow" data-url="${url}"><span class='fileName'>${fileName} ${fileSize + unitStr}</span><img class='iconPng' src='/imAdmin/images/${formatObj.img}' /></div>`
    } else {
      if (formatObj) {
        html = `<a href='${url}' download='${formatObj.format == 'txt' ? url : ''}' target="_blank" title='download(${fileSize + unitStr})' class='download-file f-maxWid msg-file'><span class='fileName'>${fileName} ${fileSize + unitStr} </span><img class='iconPng' src='/imAdmin/images/${formatObj.img}' /></a>`
      } else {
        html = `<a href='${url}' target="_blank" title='download(${fileSize + unitStr})' class='download-file f-maxWid msg-file'><span class='fileName'>${fileName} ${fileSize + unitStr} </span><img class='iconPng' src='/imAdmin/images/file-b-_file.png' /></a>`
      }
    }
    return html
  },
  //解析位置消息元素
  convertLocationMsgToHtml (content) {
    return '经度=' + content.getLongitude() + ',纬度=' + content.getLatitude() + ',描述=' + content.getDesc();
  },
  //解析自定义消息元素
  convertCustomMsgToHtml (conversationID, content, judge) {
    let text = '', desc = content.description || content.Desc, data = content.data || content.Data, ext = content.extension || content.Ext, isObj = this.typeObject(data)
    if (isObj) {
      let isObj2 = this.typeObject(isObj.data), mediaText
      if (isObj2 && isObj.inviter) {
        desc = isObj2.desc
        data = isObj2.data
        ext = isObj2.ext
      } else if (!isObj.url) {//文件自定义消息排除
        desc = isObj.description || isObj.Desc
        data = isObj.data || isObj.Data
        ext = isObj.extension || isObj.Ext
      }
      if (!data && isObj.inviter) {
        mediaText = this.parseCallMsg(isObj)
        text = `<div class='msg-text'>${mediaText}</div>`
        return text
      }
    }
    if (desc == 'text' || desc == 'SystemInformTitle' || desc == 'signIn' || this.classStatus.indexOf(desc) > -1) {
      text = this.convertTextMsgToHtml(conversationID, data, judge, desc, ext);
    } else if (desc == 'audio-join') {
      text = `<div class='msg-text'>[${langText(data)}]</div>`
    } else if (desc == 'audio-leave') {
      if (data == 'audioTime') {
        text = `<div class='msg-text'>[${langText(data)}: ${this.s_to_hs(ext)}]</div>`
      } else {
        text = `<div class='msg-text'>[${langText(data)}]</div>`
      }
    } else if (desc == 'video-join') {
      text = `<div class='msg-text'>[${langText(data)}]</div>`
    } else if (desc == 'video-leave') {
      if (data == 'videoTime') {
        text = `<div class='msg-text'>[${langText(data)}: ${this.s_to_hs(ext)}]</div>`
      } else {
        text = `<div class='msg-text'>[${langText(data)}]</div>`
      }
    } else if (data == "group_create") {
      text = judge ? langText('group_create') : `<div class='msg-text'>${langText('group_create')}</div>`;
    } else if (desc == 'file-img') {
      text = judge ? langText('image') : this.convertImageMsgToHtmlDb(data)
    } else if (desc == 'file-file') {
      if (judge) {
        text = langText('file')
      } else {
        data = JSON.parse(data)
        text = this.convertFileMsgToHtmlDb(data.url, data.size, data.name)
      }
    } else if (desc == 'invite') {
      text = data
    } else if (desc == 'groupSet') {
      console.err('groupSet')
    } else if (desc == 'autoReply') {
      text = langText('autoReply')
    } else if (desc == 'service') {
      let serviceData = null
      if (serviceData) {
        for (let i = 0, len = serviceData.length; i < len; i++) {
          let ele = serviceData[i];
          if (ele.Id == data.Pid) {
            for (let j = 0, len = ele.Children.length; j < len; j++) {
              let ele2 = ele.Children[j];
              if ((ele2.Pid == data.Pid) && (ele2.Id == data.Id)) {
                text = ele2.Question
              }
            }
          }
        }
      }
    } else if (desc == 'phone-call' || desc == 'phone-cancel') {
      text = `<div class='msg-text'>[${langText(desc)}]</div>`
    } else if (desc == 'phoneTime') {
      text = `<div class='msg-text'>[${langText(desc)}: ${data}]</div>`
    } else if (desc == 'msgAt' || desc == 'msgCite') {
      text = data
    }
    return this.formatText2Node(text)
  },
  //解析群提示消息元素
  convertGroupTipMsgToHtml (content) {
    let WEB_IM_GROUP_TIP_MAX_USER_COUNT = 10, text = "", opType, opUserId = content.operatorID, userIDList;
    opType = content.operationType, teamId = content.groupProfile.groupID; //群提示消息类型（操作类型)
    switch (opType) {
      case TIM.TYPES.GRP_TIP_MBR_JOIN: //加入群
        break;
      case TIM.TYPES.GRP_TIP_MBR_QUIT: //退出群
        text += opUserId + langText('tipsMemberLeave') + content.memberCount;
        break;
      case TIM.TYPES.GRP_TIP_MBR_KICKED_OUT: //踢出群
        text += opUserId + langText('will');
        userIDList = content.userIDList;
        for (let m of userIDList) {
          let name = m;
          text += name + ",";
          if (userIDList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT) {
            text += "...... " + userIDList.length + langText('members');
            break;
          }
        }
        text = text.substring(0, text.length - 1);
        text += langText('tipsMemberKicked');
        break;
      case TIM.TYPES.GRP_TIP_MBR_SET_ADMIN: //设置管理员
        text += opUserId + langText('will');
        userIDList = content.userIDList;
        for (let m of userIDList) {
          let name = m;
          text += name + ",";
          if (userIDList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT) {
            text += "......" + userIDList.length + langText('members');
            break;
          }
        }
        text = text.substring(0, text.length - 1);
        text += langText('setAdministrator');
        break;
      case TIM.TYPES.GRP_TIP_MBR_CANCELED_ADMIN: //取消管理员
        text += opUserId + langText('cancel');
        userIDList = content.userIDList;
        for (let m of userIDList) {
          let name = m;
          text += name + ",";
          if (userIDList.length > WEB_IM_GROUP_TIP_MAX_USER_COUNT) {
            text += "......" + userIDList.length + langText('members');
            break;
          }
        }
        text = text.substring(0, text.length - 1);
        text += langText('AdministratorQualification');
        break;

      case TIM.TYPES.GRP_TIP_GRP_PROFILE_UPDATED: //群资料变更
        text += opUserId + langText('modifiedGroupInformation');
        let groupInfoList = content.newGroupProfile;
        for (let m in groupInfoList) {
          let value = groupInfoList[m];
          switch (m) {//待补充
            case 'name':
              text += langText('GroupNameIs') + value + "; ";
              break;
            case TIM.TYPES.GRP_PROFILE_NOTIFICATION:
              text += langText('notificationIs') + value + "; ";
              break;
            case TIM.TYPES.GRP_PROFILE_INTRODUCTION:
              text += langText('introductionIs') + value + "; ";
              break;
            case TIM.TYPES.GRP_PROFILE_OWNER_ID:
              let userID = content.operatorID;
              text += userID + langText('transferGroup') + value + "; ";
              break;
            case 'groupCustomField':
              for (let i = 0, len = value.length; i < len; i++) {
                let ele = value[i];
                text += (i > 0 ? ' , ' : '') + langText(`Is${ele.key}${ele.value || 0}`)
              }
              break;
            default:
              text += "unknow :type=" + m + ",value=" + value + "; ";
              break;
          }
        }
        break;
      default:
        text += "unknow：type=" + opType;
        break;
    }
    return text;
  },
  classStatusUI (desc, data) {
    let text = '', obj = {}, style = 'font-size:18px;font-weight:600;color:#333;display: block;margin-bottom:5px;'
    for (let key in data) {
      obj[key.toLowerCase()] = data[key]
    }
    switch (desc) {
      case 'AbsenceReminder':
        text = `<title style='${style}'>Absence Reminder</title>
            <p>Class ID : ${obj.classid}</p>
            <p>Class Time : ${new Date(obj.classtime).toLocaleString()}</p>
            <p>${obj.remark}</p>`
        break;
      case 'CancellationReminder':
        text = `<title style='${style}'>Cancellation Reminder</title>
            <p>Cancellation Status: ${obj.cancellationstatus}</p>
            <p>Operation Type: ${obj.operationtype}</p>
            <p>Operation Time: ${new Date(obj.operationtime).toLocaleString()}</p>
            <p>Cancellation details: ${obj.cancellationdetails}</p>`
        break;
      case 'BookingReminder':
        text = `<title style='${style}'>Booking Reminder</title>
            <p>Class ID: ${obj.classid}</p>
            <p>Class Time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Class Type: ${obj.classtype}</p>
            <p class='${obj.remark ? '' : 'hide'}'>${obj.remark}</p>`
        break;
      case 'ClassReminder':
        text = `<title style='${style}'>Class Reminder</title>
            <p>${obj.remark}</p><p>Class ID: ${obj.classid}</p>
            <p>Class Time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Class Type: ${obj.classtype}</p>`
        break;
      case 'ComplaintReminder':
        text = `<title style='${style}'>Complaint Reminder</title>
            <p>Class ID: ${obj.classid}</p>
            <p>Class Time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Generation Time: ${new Date(obj.generationtime).toLocaleString()}</p>
            <p>Complainant: ${obj.complainant}</p>
            <p>Complaint Type: ${obj.complainttype}</p>
            <p>Complaint Reason: ${obj.complaintreason}</p>
            <p>${obj.remark}</p>`
        break;
      case 'ShiftClockReminder':
        text = `<title style='${style}'>Shift clock-in reminder</title>
            <p>${obj.remark}</p>`
        break;
      case "ComplaintWithdrawnReminder":
        text = `<title style='${style}'>Complaint withdrawn reminder</title>
            <p>${obj.remark}</p>`
        break;
      case "SVIPBookingReminder":
        text = `<title style='${style}'>SVIP Booking reminder</title>
            <p>Class ID: ${obj.classid}</p>
            <p>Class Time: ${new Date(obj.classtime).toLocaleString()}</p>
            <p>Class Type: ${obj.classtype}</p>
            <p>${obj.remark}</p>`
      default:
        break;
    }
    return text
  }
}